import { render } from "./Main.vue?vue&type=template&id=4b7af349&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4b7af349&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4b7af349"

export default script